<template>
  <div>
    <div v-if="!displayDeck" class="row">
      <div class="col-12 text-end">
        <button class="btn btn-link" v-on:click="displayDeck = !displayDeck">Voir la pioche</button>
      </div>
    </div>
    <div v-else class="row">
      <div class="col-12 text-end">
        <button class="btn btn-link" v-on:click="displayDeck = !displayDeck">
          Masquer la pioche</button>
      </div>
      <div class="col-12 small" v-if="deck.length > 0">
        Nombre de lettres restantes : {{deck.length}}
      </div>
      <div class="col-12" v-if="deck.length > 0">
        <span v-for="(l, index) in deck" v-bind:key="index" class="tile">{{l}}</span>
      </div>
      <div class="col-12 small" v-else>
        Aucune lettre restante dans la pioche.
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'InfoBoard',
  props: {
    deck: Array,
  },
  data() {
    return {
      displayDeck: false,
    };
  },
};
</script>

<style scoped>
.tile{
  background-color: #eecf92;
  font-weight: bold;
  font-family: arial;
  position: relative;
  text-align: center;
  font-size: 0.8rem;
  display: block;
  float: left;
  width: 18px;
  margin-right: 2px;
  margin-top: 2px;
}
.btn-link{
  font-size: 0.8rem;
}
</style>
